import { apiSlice } from "features/api/apiSlice";
import { transformDoctor } from "./transformDoctor";

const getDoctor = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getDoctor: build.query({
      query: (id) => `/doctors/mwell/${id}`,
      transformResponse: (res) => transformDoctor(res.d.data),
      providesTags: (result) =>
        result ? [{ type: "Doctor", id: result.id }] : ["Doctor"],
    }),
  }),
});

export const { useGetDoctorQuery, useLazyGetDoctorQuery } = getDoctor;
